module.exports = __webpack_public_path__ + "assets-cabinet/img/trans.7dae59b5.svg";